import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Card from '@material-ui/core/Card';
import WeightScale from '../../../../icons/weighting-scale.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import { getHealthClassName } from '../../../Helpers/Lists/HealthClass';
import NumberFormat from 'react-number-format';
import { capitalize } from '@material-ui/core';
import { OneClickProductType } from '../../../Common/Constant';
import CurrencyFormat from '../../../Common/formatters/CurrencyFormat';
import GetYearList from '../../../Helpers/Lists/YearList';
import './RequestSummary.scss';

export default function RequestSummary(props) {
  const { insuredInfo, clientInfo, data, isSubmitCase } = props;
  const [selectedQuotes, setSelectedQuotes] = useState([]);
  const solicitationDate = data.basicInfo.pages.applicationInformation ? data.basicInfo.pages.applicationInformation.solicitationDate : '';
  const solicitationState = data.basicInfo.pages.applicationInformation ? data.basicInfo.pages.applicationInformation.solicitationState : '';
  const deliveryState = data.basicInfo.pages.applicationInformation ? data.basicInfo.pages.applicationInformation.deliveryState : '';
  const ownerState = data.basicInfo.pages.applicationInformation ? data.basicInfo.pages.applicationInformation.applicationState : ''
  const oneClickProductType = data.oneClickProductType ? data.oneClickProductType : '';
  const isSurvivorshipPolicy = props.isSurvivorshipPolicy;
  const benefitDurationOptionMinYearValue = isSurvivorshipPolicy ? 4 : 2;
  const getBenefitDurationLabel = (value) => GetYearList(benefitDurationOptionMinYearValue, 8, isSurvivorshipPolicy).map((bd) => bd.value === value ? bd.label : null);

  useEffect(() => {
    if (props.isTerm && props.selectedQuote) {
      setSelectedQuotes([props.selectedQuote]);
      return;
    }
    if (insuredInfo && isSubmitCase) {
      if (props.isDICreateCase) {
        let submitdata = [{
          coverage: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.coverage,
          carrier: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.carrierName,
          product: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.product,
          benefitPeriod: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.benefitPeriod,
          eliminationPeriod: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.eliminationPeriod,
          benefitPeriodOther: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.benefitPeriodOther,
        }];
        setSelectedQuotes(submitdata);
      } else {
        let submitdata = [{
          premium: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.category.toUpperCase() === 'LTC' ? data.basicInfo.pages.selectProduct.premium === 'specificPremium' ? data.basicInfo.pages.selectProduct.specificPremium : data.basicInfo.pages.selectProduct.premium : data.basicInfo.pages.selectProduct.recurringAnnualPremium,
          coverage: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.coverage,
          carrier: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.carrierName,
          premiumMode: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.premiumMode,
          benefitDuration: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.benefitDuration,
          infBenefit: '',
          returnPremium: '',
          interestRate: '',
          product: data.basicInfo.pages.selectProduct && data.basicInfo.pages.selectProduct.product,
        }];
        setSelectedQuotes(submitdata);
      }
      return;
    }
    if (data.isPermIllustration) {
      return
    }
    if (props.data.basicInfo.pages.quoter && props.data.basicInfo.pages.quoter.selectedQuotes && props.data.basicInfo.pages.quoter.selectedQuotes.length !== 0) {
      setSelectedQuotes(props.data.basicInfo.pages.quoter.selectedQuotes);
    }
  }, [])

  const getInsuredName = () => {
    if (insuredInfo && insuredInfo.proposedInsuredFirstName && insuredInfo.proposedInsuredLastName) {
      return insuredInfo.proposedInsuredFirstName + ' ' + insuredInfo.proposedInsuredLastName;
    }
    else if (clientInfo && clientInfo.clientName) {
      return clientInfo.clientName;
    }
    else {
      return clientInfo && clientInfo.firstName ? clientInfo.firstName : '';
    }
  }

  const getSecondInsuredName = () => {
    if (isSurvivorshipPolicy && data.basicInfo && data.basicInfo.pages && data.basicInfo.pages.insuredBasicInfo) {
      if (data.oneClickProductType && (data.oneClickProductType === OneClickProductType.MorganStanleyLTCQ)) {
        return (data.basicInfo.pages.insuredBasicInfo.insuredInfo[1].proposedInsuredFirstName + ' ' + data.basicInfo.pages.insuredBasicInfo.insuredInfo[1].proposedInsuredLastName);
      }
      else {
        return (data.basicInfo.pages.insuredBasicInfo.secondaryInsuredFirstName + ' ' + data.basicInfo.pages.insuredBasicInfo.secondaryInsuredLastName);
      }
    }
    return '';
  }

  const selectedTermQuote = props.selectedQuote && (
    <Card className="license mt-2">
      <Row>
        <Col>
          <b id="product-details-header">Product Details</b>
        </Col>
      </Row>
      <Fragment>
        <Row>
          <Col>
            <div id="product-details-carrier-label" className="stat-title">Carriers</div>
            <div id="product-details-carrier" className="stat-text">{props.selectedQuote.carrierName || 'N/A'}</div>
          </Col>
          <Col>
            <div id="product-details-plan-label" className="stat-title">Plan Name</div>
            <div id="product-details-plan" className="stat-text">{props.selectedQuote.product || 'N/A'}</div>
          </Col>
        </Row>
      </Fragment>
      <Fragment>
        <Row>
          <Col>
            <div id="product-details-premium-label" className="stat-title">Modal Premium</div>
            <div id="product-details-premium" className="stat-text"><NumberFormat displayType={'text'} prefix={'$'} value={props.selectedQuote.premium} thousandSeparator={true} /></div>
          </Col>
          <Col>
            <div id="product-details-coverage-length-label" className="stat-title">Coverage Length</div>
            <div id="product-details-coverage-length" className="stat-text">{`${props.selectedQuote.term} Years`}</div>
          </Col>
        </Row>
      </Fragment>
      <Row>
        <Col>
          <div id="product-details-Payment-label" className="stat-title">Payment Frequnecy</div>
          <div id="product-details-Payment" className="stat-text">{capitalize(props.selectedQuote.premiumAs) || 'N/A'}</div>
        </Col>
        <Col>
          <div id="product-details-coverage-amount-label" className="stat-title">Coverage Amount</div>
          <div id="product-details-coverage-amount" className="stat-text"><NumberFormat displayType={'text'} prefix={'$'} value={props.selectedQuote.coverageAmount} thousandSeparator={true} /></div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div id="product-details-health-label" className="stat-title">Health Class</div>
          <div id="product-details-health" className="stat-text">{getHealthClassName(props.selectedQuote.healthClass) || 'N/A'}</div>
        </Col>
        <Col>
          <div id="product-details-tobbaco-label" className="stat-title">Tobacco Use</div>
          <div id="product-details-tobbaco" className="stat-text">{insuredInfo.tobacco === 'true' ? 'Have Used in the Last 12 Months' : 'Do Not Use Tobacco'}</div>
        </Col>
      </Row>
    </Card>
  )

  const selectedDIQuote = (
    selectedQuotes.map((item, i) => {
      return (
        <Card className="license mt-2" key={i}>
          <Row>
            <Col className='mb-2'>
              <b id="product-details-header">Product Details</b>
            </Col>
          </Row>
          {props.isSubmitCase && <Fragment>
            <Row>
              <Col>
                <div id="product-details-coverage-label" className="stat-title">Coverage (Monthly Disability Benefit)</div>
                <div id="product-details-coverage" className="stat-text">{<CurrencyFormat number={item.coverage} /> || 'N/A'}</div>
              </Col>
            </Row>
          </Fragment>}
          <Fragment>
            <Row>
              <Col>
                <div id="product-details-carrier-label" className="stat-title mb-1">Carriers</div>
                <div id="product-details-carrier" className="stat-text mb-2">{item.carrier}</div>
              </Col>
              <Col>
                <div id="product-details-plan-label" className="stat-title mb-1">Plan Name</div>
                <div id="product-details-plan" className="stat-text mb-2">{item.product}</div>
              </Col>
            </Row>
          </Fragment>
          <Row>
            <Col>
              <div id="product-details-inflation-benefit-label" className="stat-title mb-1">Benefit Period</div>
              <div id="product-details-inflation-benefit" className="stat-text mb-2">{(item.benefitPeriod && item.benefitPeriod.toLowerCase() === 'other') ? (item.benefitPeriodOther || "N/A") : (item.benefitPeriod || "N/A")}</div>
            </Col>
            <Col>
              <div id="product-details-return-premium-label" className="stat-title mb-1">Elimination Period</div>
              <div id="product-details-return-premium" className="stat-text mb-2">{item.eliminationPeriod || "N/A"}</div>
            </Col>
          </Row>
        </Card>)
    })
  )

  return (
    <Col md={{ span: 5, offset: 1 }} className='px-5'>
      <div className="text-center mb-3 mt-4">
        <SvgIcon id="weightscale-icon" color="primary" className="iconsSvg" component={WeightScale} />
      </div>

      {props.isTerm === true ? <h4 id="qoute-summary-header" className="text-center"><b>Term Quote Summary</b></h4> : props.isSubmitCase === true ? <h4 className="text-center"><b>Quote Summary</b></h4> : <h4 className="text-center"><b>Illustration request summary</b></h4>}

      <div className='Term-Life-Insurance justify-content-center'>
        {oneClickProductType !== OneClickProductType.MorganStanleyULR &&
          <React.Fragment>
            {props.isTerm ? selectedTermQuote
              : (props.isDICreateCase ? selectedDIQuote
                : (selectedQuotes.map((item, i) => {
                  return (
                    <Card className="license mt-2" key={i}>
                      <Row>
                        <Col className='mb-2'>
                          <b id="product-details-header">Product Details</b>
                        </Col>
                      </Row>
                      {props.isSubmitCase && <Fragment>
                        <Row>
                          <Col>
                            <div id="product-details-category-label" className="stat-title">{data.basicInfo.pages.selectProduct.category.toUpperCase() === 'LTC' ? 'Premium Amount' : 'Annual Premium Amount'}</div>
                            <div id="product-details-category" className="stat-text">{<CurrencyFormat number={item.premium} /> || 'N/A'}</div>
                          </Col>
                          <Col>
                            <div id="product-details-coverage-label" className="stat-title">Coverage (Death Benefit)</div>
                            <div id="product-details-coverage" className="stat-text">{<CurrencyFormat number={item.coverage} /> || 'N/A'}</div>
                          </Col>
                        </Row>
                      </Fragment>}
                      <Fragment>
                        <Row>
                          <Col>
                            <div id="product-details-carrier-label" className="stat-title mb-1">Carriers</div>
                            <div id="product-details-carrier" className="stat-text mb-2">{item.carrier}</div>
                          </Col>
                          {item && item.product &&
                            <Col>
                              <div id="product-details-plan-label" className="stat-title mb-1">Plan Name</div>
                              <div id="product-details-plan" className="stat-text mb-2">{item.product}</div>
                            </Col>
                          }
                        </Row>
                      </Fragment>
                      <Fragment>
                        <Row>
                          <Col>
                            <div id="product-details-premium-mode-label" className="stat-title mb-1">Premium Mode</div>
                            <div id="product-details-premium-mode" className="stat-text mb-2">{item.premiumMode || "N/A"}</div>
                          </Col>
                          <Col>
                            <div id="product-details-benefit-duration-label" className="stat-title mb-1">Benefit Duration</div>
                            <div id="product-details-benefit-duration" className="stat-text mb-2 text-capitalize">{item.benefitDuration ? getBenefitDurationLabel(item.benefitDuration) : "N/A"}</div>
                          </Col>
                        </Row>
                      </Fragment>
                      <Row>
                        <Col>
                          <div id="product-details-inflation-benefit-label" className="stat-title mb-1">Inflation Benefit Option</div>
                          <div id="product-details-inflation-benefit" className="stat-text mb-2">{item.infBenefit || "N/A"}</div>
                        </Col>
                        <Col>
                          <div id="product-details-return-premium-label" className="stat-title mb-1">Return of  Premium</div>
                          <div id="product-details-return-premium" className="stat-text mb-2">{isSubmitCase ? "N/A" : item.returnPremium ? 'Yes' : 'No'}</div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div id="product-details-interest-rate-label" className="stat-title mb-1">Assumed Interest Rate</div>
                          <div id="product-details-interest-rate" className="stat-text mb-2">{item.interestRate || "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  )
                }))
              )}
          </React.Fragment>
        }
        <Card className="license mt-2">
          <Row>
            <Col className='mb-2'>
              <b id="pi-owner-header">Proposed Insured & Owner</b>
            </Col>
          </Row>
          <Fragment>
            <Row>
              <Col>
                <div id="proposed-ins-user-label" className="stat-title mb-1">Proposed Insured</div>
                <div id="proposed-ins-user" className="stat-text mb-2">{getInsuredName()}</div>
              </Col>
              <Col>
                <div id="proposed-ins-health-class-label" className="stat-title mb-1">Health Class</div>
                <div id="proposed-ins-health-class" className="stat-text mb-2">{props.selectedQuote && props.selectedQuote.healthClass ? getHealthClassName(props.selectedQuote.healthClass) || 'N/A' : 'N/A'}</div>
              </Col>
            </Row>
            <Row>
              {isSurvivorshipPolicy &&
                <Col className='col-6'>
                  <div id="second-ins-user-label" className="stat-title mb-1">Second Insured Name</div>
                  <div id="second-ins-user" className="stat-text mb-2">{getSecondInsuredName()}</div>
                </Col>}
              <Col className='col-6'>
                <div id="proposed-ins-solicitation-date-label" className="stat-title mb-1">Solicitation Date </div>
                <div id="proposed-ins-solicitation-date" className="stat-text mb-2">{solicitationDate}</div>
              </Col>
              <Col className='col-6'>
                <div id="proposed-ins-solicitation-state-label" className="stat-title mb-1">Solicitation State</div>
                <div id="proposed-ins-solicitation-state" className="stat-text mb-2">{solicitationState}</div>
              </Col>
              <Col className='col-6'>
                <div id="proposed-ins-owner-state-label" className="stat-title mb-1">Owner State </div>
                <div id="proposed-ins-owner-state" className="stat-text mb-2">{ownerState}</div>
              </Col>
              <Col className='col-6'>
                <div id="proposed-ins-delivery-state-label" className="stat-title mb-1">Delivery State</div>
                <div id="proposed-ins-delivery-state" className="stat-text mb-2">{deliveryState}</div>
              </Col>
            </Row>
          </Fragment>
        </Card>
      </div>

    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SubComponents/RequestSummary.js